var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDescRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.479 33.385h-3.043a1.518 1.518 0 01-1.521-1.522c0-.843.678-1.521 1.52-1.521h3.044c.843 0 1.521.678 1.521 1.521 0 .843-.678 1.522-1.521 1.522zm0-8.114h-7.1a1.518 1.518 0 01-1.521-1.522c0-.843.678-1.521 1.521-1.521h7.1c.843 0 1.521.678 1.521 1.521 0 .843-.678 1.522-1.521 1.522zm0-8.114H23.322a1.518 1.518 0 01-1.521-1.522c0-.843.678-1.521 1.521-1.521h11.157c.843 0 1.521.678 1.521 1.521 0 .843-.678 1.522-1.521 1.522zm0-8.114H19.265a1.518 1.518 0 01-1.521-1.522c0-.843.678-1.521 1.521-1.521h15.214C35.322 6 36 6.678 36 7.521c0 .843-.678 1.522-1.521 1.522z"
  })));
}
export default SvgSortDescRight;